// Module
var code = "<svg viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.375 12.5a1 1 0 0 0 1.25 0l2.149-1.72c.738-.59.32-1.78-.625-1.78H7.851c-.946 0-1.363 1.19-.625 1.78l2.15 1.72z\"/></svg>";
// Exports
module.exports = code;